var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___MnRGY2",
  "NI": "FloatingUnreadIndicators.module__slot___MnRGY2",
  "AH": "FloatingUnreadIndicators.module__slotTop___MnRGY2",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___MnRGY2",
  "q3": "FloatingUnreadIndicators.module__indicator___MnRGY2",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___MnRGY2",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___MnRGY2",
};

module.exports = exports;
